import React from "react";
import moment from "moment";
import { Table, Spin } from "antd";
import { EventSubscription } from "../../../../../interfaces/common/event_subscription";

interface EventSubscriptionsTableProps {
  isLoading: boolean;
  data: EventSubscription[];
}

const EventSubscriptionsTable = ({ isLoading, data }: EventSubscriptionsTableProps) => {
  const DATE_FORMAT = "MMM DD, YYYY HH:mm";

  const getEventSubscriptionsColumns = () => {
    return [
      { title: "Event", dataIndex: "event", key: "event" },
      {
        title: "Platforms",
        dataIndex: "target_platforms",
        key: "target_platforms",
        render: (targetPlatforms: string[]) => targetPlatforms.join(", "),
      },
      {
        title: "Date",
        dataIndex: "created_at",
        key: "created_at",
        render: (date: string) => {
          return moment(date).format(DATE_FORMAT);
        },
      },
    ];
  };

  const columns = getEventSubscriptionsColumns();

  return (
    <>
      {isLoading ? (
        <div className="organization-roles spinning">
          <Spin tip="fetching roles..." />
        </div>
      ) : (
        <div className="organization-roles-table">
          <Table dataSource={data} columns={columns} size="small" scroll={{ x: 800 }} />
        </div>
      )}
    </>
  );
};

export default EventSubscriptionsTable;
